// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 245 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"245":"280e2f2f3dc2cdd7fa9c","522":"07a3a7d49b72e48ba9b6"}[chunkId] + ".js";
};